import React from 'react';
import ReactDOM from 'react-dom';
import superagent from 'superagent';

import {FormControl, FormGroup, ControlLabel, Button, Col, PageHeader} from 'react-bootstrap';
import styles from './LoginForm.css';
import { Login, LoggedUserJazyk } from '../login/Login';
import {UserDetailOsoba} from './UserDetailOsoba'
import {UserDetailHeslo} from './UserDetailHeslo'

import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({
 en:{
   h2:"USER ACCOUNT SETTING"
 },
 cs: {
   h2:"NASTAVENÍ UŽIVATELSKÉHO ÚČTU"
 }
});



export class UserDetail extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    strings.setLanguage(LoggedUserJazyk());

    return (
      <div className={styles.root + " row"}>
        <h1 className={styles.panelHeader + " col-12"}>{strings.h2}</h1>
        <div className={"col-md-6 mb-3"}>
          <div className={styles.userPanel+" shadow"}>
            <UserDetailOsoba setUser={this.props.setUser} />
          </div>
        </div>
        <div className={"col-md-6 mb-3"}>
          <div className={styles.newUserPanel+" shadow"}>
            <UserDetailHeslo />
          </div>
        </div>
      </div>

    )

    return (
      <div className={styles.root + "row"}>
        <h1 className={styles.panelHeader}>{strings.h2}</h1>
        <div className={"col-md-6 " + styles.objednavkaPanel}>
          <UserDetailOsoba setUser={this.props.setUser} />
        </div>
        <div className={styles.clear}></div>

        <div className={"col-md-6 " + styles.platbaPanel}>
          <UserDetailHeslo />
        </div>
        <div className={styles.clear}></div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// src/components/login/UserDetail.jsx